import { LOCALE_ID, Inject, Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  env = environment;
  shortLocale='en';
  flag = 'en';
  baseUrl = '';

  constructor( @Inject(LOCALE_ID) public locale: string) {
    var localParts = locale.split('-');
    if (localParts.length > 0) {
      this.shortLocale = localParts[0];
      this.flag = localParts[0].toLowerCase();
    }
    if(localParts.length > 1) {
      this.flag = localParts[1].toLowerCase();
    }
    if(this.flag == 'en') {
      this.flag = 'us';
    }
    this.baseUrl = '//'+document.location.host;


  }

  ngOnInit() {
  }

}
